import { render, staticRenderFns } from "./NivelBodegaComponent.vue?vue&type=template&id=421d425c&"
import script from "./NivelBodegaComponent.vue?vue&type=script&lang=js&"
export * from "./NivelBodegaComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports